import AWS from "aws-sdk";
 const combinedKeys = 'AKIA2J6ITW3POEEWUNQQZZzc7GgLwq+5mewbJdonuURfvf/0A0rCBp/uXZjGef'
const API_KEY =  combinedKeys.split('ZZ')[0]
const SECERT_KEY = combinedKeys.split('ZZ')[1]
const documentClient = new AWS.DynamoDB.DocumentClient({
  region: "ap-southeast-1",
  endpoint: "dynamodb.ap-southeast-1.amazonaws.com",
  accessKeyId: API_KEY,
  secretAccessKey: SECERT_KEY
});
export const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider(
  {
    apiVersion: "2016-04-18",
    region: "ap-southeast-1",
    accessKeyId: API_KEY,
    secretAccessKey: SECERT_KEY
  }
);

export default documentClient;
